import { get, patch } from '@/helpers/http';

export function fetchNotifications(pagination = {}) {
  return get('/user/notifications', { ...pagination });
}

export function markNotificationAsRead(id, now) {
  return patch(`/notifications/read/${id}`, { readed_at: now });
}

export function markAllNotificationsAsReaded(now) {
  return patch('/notifications/read/all', { readed_at: now });
}
